module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightcloud@3-e594fcb717614a9e492edd0dc4bb3db3.png";